module.exports = __webpack_public_path__ + "static/img/graphswiper1.7fd2a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphswiper1.png
// module id = A8mn
// module chunks = 170